// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bulk-importer-modal.modal--large {
    max-width: 960px;
}

.bulk-importer {
    --bulk-border: var(--invoice-border, #d9dedb);
    --bulk-muted: var(--invoice-muted, #65746e);
    --bulk-panel: var(--invoice-panel, #ffffff);
    --bulk-soft: var(--invoice-panel-soft, #f7f9f8);
    --bulk-text: var(--invoice-text, #1d2e23);
    display: flex;
    flex-direction: column;
    gap: 1rem;
    color: var(--bulk-text);
}

.bulk-importer__intro p {
    margin: 0;
}

.bulk-importer__intro p + p {
    margin-top: 0.4rem;
}

.bulk-importer__upload {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    padding: 1rem;
    border: 1px dashed var(--bulk-border);
    background: var(--bulk-soft);
}

.bulk-importer__upload label,
.bulk-importer__mapping strong,
.bulk-importer__file-summary label {
    font-weight: 700;
}

.bulk-importer__upload small,
.bulk-importer__mapping small,
.bulk-importer__file-summary span,
.bulk-importer__section-heading p {
    color: var(--bulk-muted);
}

.bulk-importer__file-summary {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.8rem;
    border: 1px solid var(--bulk-border);
    background: var(--bulk-panel);
}

.bulk-importer__file-summary > div,
.bulk-importer__file-summary label {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.bulk-importer__file-summary label {
    margin-left: auto;
}

.bulk-importer__file-summary select,
.bulk-importer__mapping select {
    min-height: 38px;
}

.bulk-importer__section {
    border: 1px solid var(--bulk-border);
    background: var(--bulk-panel);
}

.bulk-importer__section-heading {
    padding: 0.75rem 1rem;
    border-bottom: 1px solid var(--bulk-border);
    background: var(--bulk-soft);
}

.bulk-importer__section-heading h3,
.bulk-importer__section-heading p {
    margin: 0;
}

.bulk-importer__section-heading h3 {
    font-size: 16px;
}

.bulk-importer__section-heading p {
    margin-top: 0.2rem;
    font-size: 13px;
}

.bulk-importer__mappings {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem;
    padding: 1rem;
}

.bulk-importer__mapping {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    min-width: 0;
}

.bulk-importer__mapping > span {
    display: flex;
    justify-content: space-between;
    gap: 0.5rem;
}

.bulk-importer__mapping em {
    color: var(--bulk-muted);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
}

.bulk-importer__preview {
    max-height: 280px;
    overflow: auto;
}

.bulk-importer__preview table {
    margin: 0;
    min-width: 100%;
}

.bulk-importer__preview th,
.bulk-importer__preview td {
    white-space: nowrap;
}

.bulk-importer__alert,
.bulk-importer__result,
.bulk-importer__progress {
    padding: 0.8rem 1rem;
    border: 1px solid var(--bulk-border);
}

.bulk-importer__alert p,
.bulk-importer__result p {
    margin: 0;
}

.bulk-importer__alert ul,
.bulk-importer__result ul {
    margin: 0.4rem 0 0;
    padding-left: 1.25rem;
}

.bulk-importer__progress {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: var(--bulk-soft);
}

.bulk-importer__result.success {
    border-color: #b7dfbd;
    background: #edf8ef;
    color: #155724;
}

.bulk-importer__actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
}

[data-theme="dark"] .bulk-importer__result.success {
    border-color: #2c5c3b;
    background: #16301f;
    color: #8fd6a0;
}

@media (max-width: 700px) {
    .bulk-importer__file-summary,
    .bulk-importer__actions {
        align-items: stretch;
        flex-direction: column;
    }

    .bulk-importer__file-summary label {
        margin-left: 0;
    }

    .bulk-importer__mappings {
        grid-template-columns: 1fr;
    }

    .bulk-importer__actions .button {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/BulkImporter/BulkImporter.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,6CAA6C;IAC7C,2CAA2C;IAC3C,2CAA2C;IAC3C,+CAA+C;IAC/C,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,qCAAqC;IACrC,4BAA4B;AAChC;;AAEA;;;IAGI,gBAAgB;AACpB;;AAEA;;;;IAII,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,oCAAoC;IACpC,6BAA6B;AACjC;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,2CAA2C;IAC3C,4BAA4B;AAChC;;AAEA;;IAEI,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;;IAGI,oBAAoB;IACpB,oCAAoC;AACxC;;AAEA;;IAEI,SAAS;AACb;;AAEA;;IAEI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI;;QAEI,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".bulk-importer-modal.modal--large {\n    max-width: 960px;\n}\n\n.bulk-importer {\n    --bulk-border: var(--invoice-border, #d9dedb);\n    --bulk-muted: var(--invoice-muted, #65746e);\n    --bulk-panel: var(--invoice-panel, #ffffff);\n    --bulk-soft: var(--invoice-panel-soft, #f7f9f8);\n    --bulk-text: var(--invoice-text, #1d2e23);\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    color: var(--bulk-text);\n}\n\n.bulk-importer__intro p {\n    margin: 0;\n}\n\n.bulk-importer__intro p + p {\n    margin-top: 0.4rem;\n}\n\n.bulk-importer__upload {\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n    padding: 1rem;\n    border: 1px dashed var(--bulk-border);\n    background: var(--bulk-soft);\n}\n\n.bulk-importer__upload label,\n.bulk-importer__mapping strong,\n.bulk-importer__file-summary label {\n    font-weight: 700;\n}\n\n.bulk-importer__upload small,\n.bulk-importer__mapping small,\n.bulk-importer__file-summary span,\n.bulk-importer__section-heading p {\n    color: var(--bulk-muted);\n}\n\n.bulk-importer__file-summary {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    gap: 1rem;\n    padding: 0.8rem;\n    border: 1px solid var(--bulk-border);\n    background: var(--bulk-panel);\n}\n\n.bulk-importer__file-summary > div,\n.bulk-importer__file-summary label {\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n}\n\n.bulk-importer__file-summary label {\n    margin-left: auto;\n}\n\n.bulk-importer__file-summary select,\n.bulk-importer__mapping select {\n    min-height: 38px;\n}\n\n.bulk-importer__section {\n    border: 1px solid var(--bulk-border);\n    background: var(--bulk-panel);\n}\n\n.bulk-importer__section-heading {\n    padding: 0.75rem 1rem;\n    border-bottom: 1px solid var(--bulk-border);\n    background: var(--bulk-soft);\n}\n\n.bulk-importer__section-heading h3,\n.bulk-importer__section-heading p {\n    margin: 0;\n}\n\n.bulk-importer__section-heading h3 {\n    font-size: 16px;\n}\n\n.bulk-importer__section-heading p {\n    margin-top: 0.2rem;\n    font-size: 13px;\n}\n\n.bulk-importer__mappings {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 1rem;\n    padding: 1rem;\n}\n\n.bulk-importer__mapping {\n    display: flex;\n    flex-direction: column;\n    gap: 0.3rem;\n    min-width: 0;\n}\n\n.bulk-importer__mapping > span {\n    display: flex;\n    justify-content: space-between;\n    gap: 0.5rem;\n}\n\n.bulk-importer__mapping em {\n    color: var(--bulk-muted);\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n}\n\n.bulk-importer__preview {\n    max-height: 280px;\n    overflow: auto;\n}\n\n.bulk-importer__preview table {\n    margin: 0;\n    min-width: 100%;\n}\n\n.bulk-importer__preview th,\n.bulk-importer__preview td {\n    white-space: nowrap;\n}\n\n.bulk-importer__alert,\n.bulk-importer__result,\n.bulk-importer__progress {\n    padding: 0.8rem 1rem;\n    border: 1px solid var(--bulk-border);\n}\n\n.bulk-importer__alert p,\n.bulk-importer__result p {\n    margin: 0;\n}\n\n.bulk-importer__alert ul,\n.bulk-importer__result ul {\n    margin: 0.4rem 0 0;\n    padding-left: 1.25rem;\n}\n\n.bulk-importer__progress {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: var(--bulk-soft);\n}\n\n.bulk-importer__result.success {\n    border-color: #b7dfbd;\n    background: #edf8ef;\n    color: #155724;\n}\n\n.bulk-importer__actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.75rem;\n}\n\n[data-theme=\"dark\"] .bulk-importer__result.success {\n    border-color: #2c5c3b;\n    background: #16301f;\n    color: #8fd6a0;\n}\n\n@media (max-width: 700px) {\n    .bulk-importer__file-summary,\n    .bulk-importer__actions {\n        align-items: stretch;\n        flex-direction: column;\n    }\n\n    .bulk-importer__file-summary label {\n        margin-left: 0;\n    }\n\n    .bulk-importer__mappings {\n        grid-template-columns: 1fr;\n    }\n\n    .bulk-importer__actions .button {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
